import AdminLogin from '../views/admin/AdminLogin.vue'
import AdminRegister from '../views/admin/AdminRegister.vue'
import AdminSecret from '../views/admin/AdminSecret.vue'
import AdminDashboard from '../views/admin/AdminDashboard.vue'
import NewProgramSetup from '../views/admin/NewProgramSetup.vue'
import EditLoyaltyProgram from '../views/admin/EditLoyaltyProgram.vue'
import UnapprovedUsers from '../views/admin/UnapprovedUsers.vue'
import ApprovedUsers from '../views/admin/ApprovedUsers.vue'
import UnapprovedRebateSubmissions from '../views/admin/UnapprovedRebateSubmissions.vue'
import ApprovedRebateSubmissions from '../views/admin/ApprovedRebateSubmissions.vue'
import ReceiptItemDetail from '../views/admin/ReceiptItemDetail.vue'
import EditLoyaltyProgramDetails from '../views/admin/EditLoyaltyProgramDetails.vue'
import CompletedTrainings from '../views/admin/CompletedTrainings.vue'
import RewardItemSubmissions from '../views/admin/RewardItemSubmissions.vue'

// guest: no auth allowed, requiresAuth: needs to be authenticated, isAdmin: needs to be an admin, empty if all allowed

const routes = [
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: {
      guest: true,
      layout: 'admin-login'
    }
  },
  {
    path: '/admin/register',
    name: 'AdminRegister',
    component: AdminRegister,
    meta: {
      guest: true
    }
  },
  {
    path: '/admin/secret',
    name: 'Secret',
    component: AdminSecret,
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: '/admin/program/create',
    name: 'NewProgramSetup',
    component: NewProgramSetup,
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: '/admin/program/edit',
    name: 'EditLoyaltyProgram',
    component: EditLoyaltyProgram,
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: '/admin/program/edit/approved-users',
    name: 'ApprovedUsers',
    component: ApprovedUsers,
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: '/admin/program/edit/unapproved-users',
    name: 'UnapprovedUsers',
    component: UnapprovedUsers,
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: '/admin/program/edit/approved-rebate-submissions',
    name: 'ApprovedRebateSubmissions',
    component: ApprovedRebateSubmissions,
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: '/admin/program/edit/unapproved-rebate-submissions',
    name: 'UnapprovedRebateSubmissions',
    component: UnapprovedRebateSubmissions,
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: '/admin/program/edit/receipt-item-detail',
    name: 'ReceiptItemDetail',
    component: ReceiptItemDetail,
    props: true,
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: '/admin/program/edit/loyalty-program',
    name: 'EditLoyaltyProgramDetails',
    component: EditLoyaltyProgramDetails,
    props: true,
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: '/admin/program/edit/completed-modules',
    name: 'CompletedTrainings',
    component: CompletedTrainings,
    props: true,
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  },
  {
    path: '/admin/program/edit/reward-items',
    name: 'RewardItemSubmissions',
    component: RewardItemSubmissions,
    props: true,
    meta: {
      requiresAuth: true,
      isAdmin: true
    }
  }
]

routes
  .filter(route => !('layout' in route.meta))
  .forEach(route => (route.meta = { ...route.meta, ...{ layout: 'admin' } }))

export { routes }
